import Vue from 'vue'
import Vuex from 'vuex'

import ConcernedInfo from '@/store/concernedInfo'
import User from '../models/User'
import UserService from '@/services/user/UserService'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: new User(),
        token: ''
    },
    getters: {
        currentUser: (state) => state.user,
        isAuthenticated: (state) => new User(state.user).isLogined(),
        token: (state) => state.token,
        isAdmin: (state) => state.user.isAdmin
    },
    mutations: {
        setCurrentUser(state, user) {
            state.user = new User(user)
        },
        setLoginState(state, authenticated) {
            state.isAuthenticated = !!authenticated
        }
    },
    actions: {
        login({commit}, {username, password}) {
            return new Promise((resolve, reject) => {
                UserService.login(username, password).then(resp => {
                    const user = new User(resp.data)
                    commit('setCurrentUser', user)
                    resolve(user)
                }).catch(err => reject(err))
            })
        },
        fetchCurrentUser({commit}) {
            return new Promise((resolve, reject) => {
                UserService.fetchCurrentUser().then(resp => {
                    const user = new User(resp.data)
                    commit('setCurrentUser', user)
                    resolve(user)
                }).catch(reject)
            })
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                UserService.logout().then(resp => {
                    resolve(resp)
                }).catch(reject)
                commit('setCurrentUser', new User())
            })
        },
        modifyPwd(_, {pwd, id}) {
            return new Promise((resolve, reject) => {
                UserService.modifyPwd(id, pwd).then(resp => {
                    if (resp.status === 200) {
                        resolve(resp)
                    } else {
                        reject(resp)
                    }
                }).catch(reject)
            })
        }
    },
    modules: {
        namespaced: true,
        ConcernedInfo
    }
})
